import { QueryKey, useQuery, UseQueryOptions } from "react-query";
import { INVENTORY_ENDPOINT } from "./constants";
import useFetchWithAuth from "../fetchWithAuth";

export type Gallery = Partial<{
  id: number;
  name: string;
  description: string;
  file_key: string;
  ref: string;
  ref_id: number;
  type: string;
  order_num: number;
  expiry: any;
  _ca: number;
  _cb: number;
  _lma: number;
  _lmb: any;
  mime: string;
  trip_id: number;
  public_url: string;
}>;

type Result = Partial<{
  success: boolean;
  statusCode: number;
  response: Array<Gallery>;
}>;
type QueryError = {};

const useTripGalleriesQuery = (
  tripId: number,
  options?: UseQueryOptions<Result, QueryError, Result, QueryKey>
) => {
  const url = `${INVENTORY_ENDPOINT}/trips/${tripId}/galleries`;
  const cacheKey = [url];
  const { fetchWithAuth } = useFetchWithAuth();

  return useQuery<Result, QueryError>(
    cacheKey,
    async () => {
      if (!tripId) throw new Error();
      return fetchWithAuth<Result>(url);
    },
    {
      ...options,
      enabled: !!tripId,
    }
  );
};
export default useTripGalleriesQuery;
